// Filtro para mostrar una url de una web sin la parte del http
export default string => string.split('//')[1] || string
